// ════════════════════════════════════════════════════════════════════════════
// components/CRM/DashboardCRM.jsx
// ✅ DASHBOARD PREMIUM - DISEÑO PROFESIONAL CON CHULERÍA DOMINICANA 😎
// ════════════════════════════════════════════════════════════════════════════
import React, { useState, useEffect } from 'react';
import {
Box,
Typography,
Grid,
Chip,
Card,
CardContent,
CircularProgress,
Alert,
Button,
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow,
Avatar,
LinearProgress,
List,
ListItem,
ListItemText,
ListItemAvatar,
Badge,
alpha,
useTheme,
CardHeader,
MenuItem,
Select,
FormControl,
IconButton,
Tooltip,
Fade,
Zoom,
Stack


} from '@mui/material';
import {

People as PeopleIcon,
Call as CallIcon,
Email as EmailIcon,
Business as BusinessIcon,
CheckCircle as CheckCircleIcon,
Warning as WarningIcon,
Refresh as RefreshIcon,

MonetizationOn as MonetizationOnIcon,
Schedule as ScheduleIcon,
BarChart as BarChartIcon,
PieChart as PieChartIcon,

Download as DownloadIcon,

Dashboard as DashboardIcon,
Star as StarIcon,
Rocket as RocketIcon,
Timeline as TimelineIcon,
AttachMoney as AttachMoneyIcon,
Percent as PercentIcon,

ArrowUpward as ArrowUpwardIcon,
ArrowDownward as ArrowDownwardIcon,

Speed as SpeedIcon
} from '@mui/icons-material';
import { Bar, Doughnut } from 'react-chartjs-2';
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
BarElement,
LineElement,
PointElement,
ArcElement,
Title,
Tooltip as ChartTooltip,
Legend,
Filler,

} from 'chart.js';
import {
getDashboardPipeline,
getOportunidades,
} from '../../services/crmService';
import { toast } from 'react-toastify';
// Registrar componentes de Chart.js
ChartJS.register(
CategoryScale,
LinearScale,
BarElement,
LineElement,
PointElement,
ArcElement,
Title,
ChartTooltip,
Legend,
Filler
);
// ════════════════════════════════════════════════════════════════════════════
// CONFIGURACIÓN DE COLORES PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const COLORS = {
primary: '#6366f1',
primaryLight: '#818cf8',
success: '#10b981',
warning: '#f59e0b',
danger: '#ef4444',
info: '#3b82f6',
purple: '#8b5cf6',
pink: '#ec4899',
dark: '#1e293b',
light: '#f8fafc'
};
const ETAPAS_CONFIG = {
contacto_inicial: {
label: 'Contacto Inicial',
color: COLORS.info,
bgcolor: '#dbeafe',
icon: BusinessIcon,
gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
},
necesidad_validada: {
label: 'Necesidad Validada',
color: COLORS.purple,
bgcolor: '#ede9fe',
icon: CallIcon,
gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)'
},
propuesta_enviada: {
label: 'Propuesta Enviada',
color: COLORS.warning,
bgcolor: '#fef3c7',
icon: EmailIcon,
gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
},
negociacion: {
label: 'En Negociación',
color: COLORS.pink,
bgcolor: '#fce7f3',
icon: AttachMoneyIcon,
gradient: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)'
},
cerrado_ganado: {
label: 'Cerrado - Ganado',
color: COLORS.success,
bgcolor: '#d1fae5',
icon: CheckCircleIcon,
gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
},
cerrado_perdido: {
label: 'Cerrado - Perdido',
color: COLORS.danger,
bgcolor: '#fee2e2',
icon: WarningIcon,
gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
}
};
const ETAPAS_ORDEN = [
'contacto_inicial',
'necesidad_validada',
'propuesta_enviada',
'negociacion',
'cerrado_ganado',
'cerrado_perdido'
];
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE KPI CARD PREMIUM - SIN ::before
// ════════════════════════════════════════════════════════════════════════════
const KpiCard = ({ title, value, icon, color, trend, trendValue, subtitle, prefix }) => {
  const IconComponent = icon;
  const isPositive = trend === 'up';
  
  return (
    <Fade in={true} timeout={800}>
      <Card sx={{
        borderRadius: 3,
        background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
        border: '1px solid',
        borderColor: alpha(color, 0.1),
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        position: 'relative',
        overflow: 'hidden', // Cambié a 'hidden' para contener el gradiente
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: `0 12px 40px ${alpha(color, 0.2)}`,
          borderColor: alpha(color, 0.3)
        }
      }}>
        {/* Barra superior como elemento separado */}
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${color} 0%, ${alpha(color, 0.7)} 100%)`,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
          zIndex: 1
        }}/>
        
        <CardContent sx={{ p: 3, position: 'relative', zIndex: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
            <Box sx={{
              p: 2,
              background: alpha(color, 0.1),
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 4px 12px ${alpha(color, 0.15)}`
            }}>
              <IconComponent sx={{
                fontSize: 28,
                color,
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))'
              }}/>
            </Box>
            
            <Box>
              <Typography 
                variant="caption" 
                sx={{ 
                  color: '#64748b',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  display: 'block',
                  mb: 1
                }}
             >
                {title}
              </Typography>
              
              <Typography 
                variant="h4" 
                sx={{ 
                  fontWeight: 800,
                  color: COLORS.dark,
                  fontSize: '2rem',
                  lineHeight: 1.2,
                  mb: 1,
                  background: `linear-gradient(135deg, ${color} 0%, ${alpha(color, 0.7)} 100%)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
             >
                {prefix}{value}
              </Typography>
              
              {subtitle && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: '#94a3b8',
                    fontSize: '0.7rem',
                    display: 'block',
                    fontWeight: 500
                  }}
               >
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
          
          {trend && (
            <Chip
              icon={isPositive ? <ArrowUpwardIcon/> : <ArrowDownwardIcon/>}
              label={`${Math.abs(trendValue)}%`}
              size="small"
              sx={{ 
                height: 28,
                fontSize: '0.75rem',
                fontWeight: 'bold',
                background: isPositive 
                  ? 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)'
                  : 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
                color: isPositive ? '#065f46' : '#991b1b',
                border: 'none',
                '& .MuiChip-icon': {
                  fontSize: 16,
                  marginLeft: '6px'
                }
              }}
           />
          )}
        </CardContent>
      </Card>
    </Fade>
  );
};
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE GRÁFICO DE PIPELINE - ESTILO PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const PipelineChart = ({ metricas }) => {
const etapasData = ETAPAS_ORDEN.map(etapa => {
const config = ETAPAS_CONFIG[etapa];
return {
label: config.label,
count: metricas[etapa]?.count || 0,
valor: metricas[etapa]?.valor || 0,
color: config.color,
gradient: config.gradient
};
});
const data = {
labels: etapasData.map(d => d.label),
datasets: [
{
label: 'Oportunidades',
data: etapasData.map(d => d.count),
backgroundColor: etapasData.map(d => d.color),
borderColor: etapasData.map(d => d.color),
borderWidth: 2,
borderRadius: 8,
borderSkipped: false,
barPercentage: 0.6,
categoryPercentage: 0.7
}
]
};
const options = {
responsive: true,
maintainAspectRatio: false,
plugins: {
legend: { display: false },
tooltip: {
backgroundColor: 'rgba(255, 255, 255, 0.98)',
titleColor: COLORS.dark,
bodyColor: '#475569',
borderColor: '#e2e8f0',
borderWidth: 1,
padding: 16,
cornerRadius: 8,
boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
titleFont: { size: 13, weight: 'bold' },
bodyFont: { size: 12 },
callbacks: {
label: (context) => {
const valor = etapasData[context.dataIndex].valor;
return [
`📊 Oportunidades: ${context.raw}`,
`💰 Valor: $${valor.toLocaleString('es-DO', { minimumFractionDigits: 2 })}`
];
}
}
}
},
scales: {
y: {
beginAtZero: true,
grid: {
color: '#f1f5f9',
drawBorder: false,
lineWidth: 1
},
ticks: {
stepSize: 1,
color: '#64748b',
font: { size: 11 }
},
border: { display: false }
},
x: {
grid: { display: false },
ticks: {
color: '#64748b',
font: { size: 11, weight: '500' }
},
border: { display: false }
}
},
animation: {
duration: 1500,
easing: 'easeInOutQuart'
}
};
return (
 <Zoom in={true} timeout={1000}>
 <Card sx={{
height: '100%',
borderRadius: 3,
background: 'white',
boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
border: '1px solid #f1f5f9',
overflow: 'hidden'
}}>
 <CardHeader
  title={
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{
        p: 1,
        background: alpha(COLORS.primary, 0.1),
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <BarChartIcon sx={{ color: COLORS.primary, fontSize: 24 }}/>
      </Box>
      <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.dark }}>
        Pipeline por Etapa
      </Typography>
    </Box>
  }
  subheader={
    <Typography variant="body2" color="text.secondary">
      Distribución de oportunidades en el funnel
    </Typography>
  }
  action={
    <Stack direction="row" spacing={1} alignItems="center">
      <Chip
        label={`${etapasData.reduce((sum, d) => sum + d.count, 0)} total`}
        size="small"
        sx={{
          bgcolor: alpha(COLORS.primary, 0.1),
          color: COLORS.primary,
          fontWeight: 'bold',
          fontSize: '0.75rem'
        }}
     />
    </Stack>
  }
  sx={{
    pb: 2,
    borderBottom: '1px solid #f1f5f9'
  }}
/>
<CardContent sx={{ p: 3, height: 'calc(100% - 85px)' }}>
  <Box sx={{ height: 320, position: 'relative' }}>
    <Bar data={data} options={options}/>
  </Box>
  
  {/* Leyenda de etapas */}
  <Box sx={{ 
    display: 'flex', 
    flexWrap: 'wrap', 
    gap: 1.5, 
    mt: 3,
    pt: 3,
    borderTop: '1px solid #f1f5f9'
  }}>
    {etapasData.map((etapa, index) => (
      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ 
          width: 12, 
          height: 12, 
          borderRadius: '50%', 
          bgcolor: etapa.color,
          border: `2px solid ${alpha(etapa.color, 0.3)}`
        }}/>
        <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem' }}>
          {etapa.label}: <Typography component="span" sx={{ fontWeight: 'bold', color: COLORS.dark }}>{etapa.count}</Typography>
        </Typography>
      </Box>
    ))}
  </Box>
</CardContent>
   </Card>
 </Zoom>
);
};
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE GRÁFICO CIRCULAR PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const ValorDistributionChart = ({ metricas }) => {
const etapasActivas = ETAPAS_ORDEN.filter(etapa => !etapa.includes('cerrado'));
const totalValor = etapasActivas.reduce((sum, etapa) => sum + (metricas[etapa]?.valor || 0), 0);
const data = {
labels: etapasActivas.map(etapa => ETAPAS_CONFIG[etapa].label),
datasets: [
{
data: etapasActivas.map(etapa => metricas[etapa]?.valor || 0),
backgroundColor: etapasActivas.map(etapa => ETAPAS_CONFIG[etapa].color),
borderWidth: 0,
spacing: 3,
borderRadius: 6
}
]
};
const options = {
responsive: true,
maintainAspectRatio: false,
plugins: {
legend: {
position: 'right',
labels: {
padding: 20,
font: { size: 11 },
color: '#64748b',
usePointStyle: true,
pointStyle: 'circle',
boxWidth: 8,
boxHeight: 8
}
},
tooltip: {
backgroundColor: 'rgba(255, 255, 255, 0.98)',
titleColor: COLORS.dark,
bodyColor: '#475569',
borderColor: '#e2e8f0',
borderWidth: 1,
padding: 16,
cornerRadius: 8,
boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
callbacks: {
label: (context) => {
const valor = context.raw;
const porcentaje = ((valor / totalValor) * 100).toFixed(1);
return `${context.label}: $${valor.toLocaleString('es-DO', { minimumFractionDigits: 2 })} (${porcentaje}%)`;
}
}
}
},
cutout: '75%',
animation: {
animateScale: true,
animateRotate: true,
duration: 1500
}
};
return (
 <Zoom in={true} timeout={1200}>
 <Card sx={{
height: '100%',
borderRadius: 3,
background: 'white',
boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
border: '1px solid #f1f5f9'
}}>
<CardHeader
  title={
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{
        p: 1,
        background: alpha(COLORS.purple, 0.1),
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <PieChartIcon sx={{ color: COLORS.purple, fontSize: 24 }}/>
      </Box>
      <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.dark }}>
        Distribución del Valor
      </Typography>
    </Box>
  }
  subheader={
    <Typography variant="body2" color="text.secondary">
      Valor total en el pipeline activo
    </Typography>
  }
  action={
    <Box sx={{ textAlign: 'right' }}>
      <Typography variant="h5" fontWeight="bold" color={COLORS.success}>
        ${totalValor.toLocaleString('es-DO', { minimumFractionDigits: 0 })}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Valor total
      </Typography>
    </Box>
  }
  sx={{
    pb: 2,
    borderBottom: '1px solid #f1f5f9'
  }}
/>
<CardContent sx={{ p: 3, height: 'calc(100% - 85px)' }}>
  <Box sx={{
    height: 280,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  }}>
    {totalValor> 0 ? (
      <>
        <Doughnut data={data} options={options}/>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center'
        }}>
          <Typography variant="h4" fontWeight="bold" color={COLORS.dark}>
            ${(totalValor / 1000000).toFixed(1)}M
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Total
          </Typography>
        </Box>
      </>
    ) : (
      <Box sx={{ textAlign: 'center', color: '#94a3b8' }}>
        <MonetizationOnIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }}/>
        <Typography variant="body2">
          No hay valor en el pipeline
        </Typography>
      </Box>
    )}
  </Box>
  
  {/* Stats adicionales */}
  {totalValor> 0 && (
    <Box sx={{ 
      mt: 3, 
      pt: 3, 
      borderTop: '1px solid #f1f5f9',
      display: 'flex',
      justifyContent: 'space-around'
    }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" fontWeight="bold" color={COLORS.dark}>
          {etapasActivas.length}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Etapas activas
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" fontWeight="bold" color={COLORS.dark}>
          ${Math.max(...etapasActivas.map(e => metricas[e]?.valor || 0)).toLocaleString('es-DO')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Mayor valor
        </Typography>
      </Box>
    </Box>
  )}
</CardContent>
   </Card>
 </Zoom>
);
};
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE TABLA DE OPORTUNIDADES - DISEÑO PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const OportunidadesRecientes = ({ oportunidades }) => {
const [filter, setFilter] = useState('activas');
const oportunidadesFiltradas = oportunidades.filter(o => {
if (filter === 'activas') return !o.etapa.includes('cerrado');
if (filter === 'ganadas') return o.etapa === 'cerrado_ganado';
if (filter === 'perdidas') return o.etapa === 'cerrado_perdido';
return true;
}).slice(0, 8);
const getProbabilidadColor = (prob) => {
if (prob>= 70) return COLORS.success;
if (prob>= 40) return COLORS.warning;
return COLORS.danger;
};
return (
 <Fade in={true} timeout={800}>
 <Card sx={{
height: '100%',
borderRadius: 3,
background: 'white',
boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
border: '1px solid #f1f5f9',
overflow: 'hidden'
}}>
<CardHeader
  title={
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{
        p: 1,
        background: alpha(COLORS.info, 0.1),
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <TimelineIcon sx={{ color: COLORS.info, fontSize: 24 }}/>
      </Box>
      <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.dark }}>
        Oportunidades Recientes
      </Typography>
    </Box>
  }
  subheader={
    <Typography variant="body2" color="text.secondary">
      Últimas actualizaciones del pipeline
    </Typography>
  }
  action={
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <Select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          sx={{
            fontSize: '0.85rem',
            borderRadius: 2,
            bgcolor: '#f8fafc'
          }}
       >
          <MenuItem value="activas">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Activas
            </Box>
          </MenuItem>
          <MenuItem value="ganadas">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Ganadas
            </Box>
          </MenuItem>
          <MenuItem value="perdidas">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Perdidas
            </Box>
          </MenuItem>
          <MenuItem value="todas">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Todas
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
      <Badge
        badgeContent={oportunidadesFiltradas.length}
        color="primary"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: 10,
            height: 20,
            minWidth: 20,
            border: '2px solid white'
          }
        }}
     />
    </Box>
  }
  sx={{
    pb: 2,
    borderBottom: '1px solid #f1f5f9'
  }}
/>
 <CardContent sx={{ p: 0 }}>
 <TableContainer>
 <Table size="medium" sx={{ minWidth: 800 }}>
 <TableHead sx={{ bgcolor: '#f8fafc' }}>
 <TableRow>
 <TableCell sx={{
fontWeight: 'bold',
fontSize: '0.8rem',
color: '#64748b',
py: 2,
pl: 3
}}>
Prospecto
 </TableCell>
 <TableCell sx={{
fontWeight: 'bold',
fontSize: '0.8rem',
color: '#64748b',
py: 2
}}>
Etapa
 </TableCell>
 <TableCell sx={{
fontWeight: 'bold',
fontSize: '0.8rem',
color: '#64748b',
py: 2
}}>
Valor
 </TableCell>
 <TableCell sx={{
fontWeight: 'bold',
fontSize: '0.8rem',
color: '#64748b',
py: 2
}}>
Probabilidad
 </TableCell>
 <TableCell sx={{
fontWeight: 'bold',
fontSize: '0.8rem',
color: '#64748b',
py: 2,
pr: 3
}}>
Responsable
 </TableCell>
 </TableRow>
 </TableHead>
 <TableBody>
{oportunidadesFiltradas.length === 0 ? (
 <TableRow>
 <TableCell colSpan={5} align="center" sx={{ py: 8 }}>
 <Box sx={{ textAlign: 'center', color: '#94a3b8' }}>
 <BusinessIcon sx={{ fontSize: 64, mb: 2, opacity: 0.5 }} />
 <Typography variant="body1" sx={{ mt: 2 }}>
No hay oportunidades {filter !== 'todas' ? filter : ''}
 </Typography>
 </Box>
 </TableCell>
 </TableRow>
) : (
oportunidadesFiltradas.map((oportunidad) => {
const etapaConfig = ETAPAS_CONFIG[oportunidad.etapa] || ETAPAS_CONFIG.contacto_inicial;
const probabilidad = oportunidad.probabilidad || 0;
const probColor = getProbabilidadColor(probabilidad);
                return (
                   <TableRow 
                    key={oportunidad.id}
                    hover
                    sx={{ 
                      cursor: 'pointer',
                      transition:  'all 0.2s ease',
                      ' &:hover': { 
                        bgcolor: alpha(etapaConfig.color, 0.03),
                        transform: 'translateX(4px)'
                      },
                      ' &:last-child td': { borderBottom: 0 }
                    }}
                  >
                     <TableCell sx={{ pl: 3, py: 2.5 }}>
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                         <Avatar 
                          sx={{ 
                            width: 40, 
                            height: 40, 
                            fontSize: '0.9rem',
                             bgcolor: alpha(etapaConfig.color, 0.1),
                            color: etapaConfig.color,
                            fontWeight: 'bold',
                             border: `2px solid ${alpha(etapaConfig.color, 0.2)}`
                          }}
                        >
                          {oportunidad.prospecto?.nombre?.charAt(0) || 'P'}
                         </Avatar>
                         <Box>
                           <Typography variant="body2" fontWeight="medium" sx={{ color: COLORS.dark }}>
                            {oportunidad.prospecto?.nombre || '-'}
                           </Typography>
                           <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                            {oportunidad.prospecto?.empresa || 'Sin empresa'}
                           </Typography>
                         </Box>
                       </Box>
                     </TableCell>
                     <TableCell sx={{ py: 2.5 }}>
                       <Chip
                        label={etapaConfig.label}
                        size="small"
                        sx={{ 
                          bgcolor: alpha(etapaConfig.color, 0.1),
                          color: etapaConfig.color,
                          fontWeight: 'bold',
                          fontSize: '0.75rem',
                          height: 26,
                          border: `1px solid ${alpha(etapaConfig.color, 0.2)}` 
                        }}
                      />
                     </TableCell>
                     <TableCell sx={{ py: 2.5 }}>
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <AttachMoneyIcon sx={{ fontSize: 16, color: COLORS.success }} />
                         <Typography variant="body2" fontWeight="bold" color={COLORS.dark}>
                          ${Number(oportunidad.valor_estimado || 0).toLocaleString('es-DO')}
                         </Typography>
                       </Box>
                     </TableCell>
                     <TableCell sx={{ py: 2.5 }}>
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: 120 }}>
                         <Box sx={{ flex: 1 }}>
                           <LinearProgress 
                            variant="determinate" 
                            value={probabilidad} 
                            sx={{ 
                              height: 8, 
                              borderRadius: 4,
                               bgcolor: alpha(probColor, 0.1),
                              ' & .MuiLinearProgress-bar': { 
                                bgcolor: probColor,
                                borderRadius: 4,
                                backgroundImage:  `linear-gradient(90deg, ${probColor} 0%, ${alpha(probColor, 0.8)} 100%)`
                              }
                            }} 
                          />
                         </Box>
                         <Typography variant="body2" fontWeight="bold" sx={{ color: probColor, minWidth: 40 }}>
                          {probabilidad}%
                         </Typography>
                       </Box>
                     </TableCell>
                     <TableCell sx={{ pr: 3, py: 2.5 }}>
                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                         <Avatar 
                          sx={{ 
                            width: 32, 
                            height: 32, 
                            fontSize: '0.8rem',
                             bgcolor: alpha(COLORS.primary, 0.1),
                            color: COLORS.primary
                          }}
                        >
                          {oportunidad.responsable?.nombre?.charAt(0) || 'U'}
                         </Avatar>
                         <Typography variant="body2" fontSize="0.875rem">
                          {oportunidad.responsable?.nombre || 'Sin asignar'}
                         </Typography>
                       </Box>
                     </TableCell>
                   </TableRow>
                );
              })
            )}
           </TableBody>
         </Table>
       </TableContainer>
     </CardContent>
   </Card>
 </Fade>
);
};
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE ALERTAS PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const AlertasSeguimientos = ({ oportunidadesVencidas }) => {
const hoy = new Date();
return (
 <Fade in={true} timeout={1000}>
 <Card sx={{
height: '100%',
borderRadius: 3,
background: 'white',
boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
border: '1px solid #f1f5f9',
overflow: 'hidden'
}}>
 <CardHeader
  title={
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{
        p: 1,
        background: alpha(COLORS.warning, 0.1),
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <WarningIcon sx={{ color: COLORS.warning, fontSize: 24 }}/>
      </Box>
      <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.dark }}>
        Alertas y Pendientes
      </Typography>
    </Box>
  }
  subheader={
    <Typography variant="body2" color="text.secondary">
      Oportunidades que requieren atención
    </Typography>
  }
  action={
    <Badge
      badgeContent={oportunidadesVencidas.length}
      color={oportunidadesVencidas.length> 0 ? "error" : "success"}
      sx={{
        '& .MuiBadge-badge': {
          fontSize: 10,
          height: 22,
          minWidth: 22,
          border: '2px solid white',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }
      }}
   >
      <Box sx={{
        p: 1,
        bgcolor: oportunidadesVencidas.length> 0 ? alpha(COLORS.danger, 0.1) : alpha(COLORS.success, 0.1),
        borderRadius: 2
      }}>
        <SpeedIcon sx={{
          color: oportunidadesVencidas.length> 0 ? COLORS.danger : COLORS.success,
          fontSize: 24
        }}/>
      </Box>
    </Badge>
  }
  sx={{
    pb: 2,
    borderBottom: '1px solid #f1f5f9'
  }}
/>
 <CardContent sx={{ p: 2 }}>
{oportunidadesVencidas.length === 0 ? (
  <Box sx={{ textAlign: 'center', py: 6, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Box sx={{ p: 3, bgcolor: alpha(COLORS.success, 0.1), borderRadius: '50%', mb: 2 }}>
      <CheckCircleIcon sx={{ fontSize: 56, color: COLORS.success }} />
    </Box>
    <Typography variant="h6" fontWeight="bold" color={COLORS.dark} sx={{ mb: 1 }}>¡Todo bajo control! 🎉</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 280 }}>
      No hay alertas pendientes.
    </Typography>
  </Box>
) : (
  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1.5 }}>
{oportunidadesVencidas.map((oportunidad, index) => {
const diasSinActividad = Math.floor(
(new Date() - new Date(oportunidad.actualizado_en)) / (1000 * 60 * 60 * 24)
);
const etapaConfig = ETAPAS_CONFIG[oportunidad.etapa] || ETAPAS_CONFIG.contacto_inicial;
            return (
    <Box key={oportunidad.id} sx={{
      p: 1.5, borderRadius: 2, bgcolor: '#f8fafc',
      border: '1px solid #f1f5f9', transition: 'all 0.3s ease',
      '&:hover': { bgcolor: 'white', transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderColor: alpha(COLORS.danger, 0.2) }
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
        <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.dark, fontSize: '0.8rem', flex: 1, mr: 1 }}>
          {oportunidad.prospecto?.nombre || 'Sin nombre'}
        </Typography>
        <Chip size="small" label={`${diasSinActividad}d`}
          sx={{ bgcolor: alpha(COLORS.danger, 0.1), color: COLORS.danger, fontWeight: 'bold', fontSize: '0.65rem', height: 18 }} />
      </Box>
      <Chip size="small" label={etapaConfig.label}
        sx={{ bgcolor: alpha(etapaConfig.color, 0.1), color: etapaConfig.color, fontSize: '0.65rem', height: 18, mb: 0.5 }} />
      {oportunidad.valor_estimado && (
        <Typography variant="caption" sx={{ display: 'block', color: COLORS.success, fontWeight: 'bold' }}>
          ${Number(oportunidad.valor_estimado).toLocaleString('es-DO')}
        </Typography>
      )}
      {oportunidad.responsable?.nombre && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          👤 {oportunidad.responsable.nombre}
        </Typography>
      )}
    </Box>
    );
  })}
  </Box>
)}
</CardContent>
   </Card>
 </Fade>
);
};
// ════════════════════════════════════════════════════════════════════════════
// COMPONENTE PRINCIPAL - DASHBOARD PREMIUM
// ════════════════════════════════════════════════════════════════════════════
const DashboardCRM = () => {
const theme = useTheme();
const [dashboardData, setDashboardData] = useState(null);
const [oportunidades, setOportunidades] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const [periodo, setPeriodo] = useState('mes');
useEffect(() => {
loadData();
}, [periodo]);
const loadData = async () => {
setLoading(true);
setError(null);
try {
  const [dashboardRes, oportunidadesRes] = await Promise.all([
    getDashboardPipeline(),
    getOportunidades()
  ]);

  // ✅ Manejar estructura: { success: true, data: { metricas: {}, oportunidades_vencidas: [] } }
  const dashboardData = dashboardRes?.data?.data || dashboardRes?.data || dashboardRes;

  // ✅ Manejar estructura: { success: true, data: { count: 44, oportunidades: [] } }
  const oportunidadesArray = oportunidadesRes?.data?.data?.oportunidades
                          || oportunidadesRes?.data?.oportunidades
                          || oportunidadesRes?.data
                          || [];

  setDashboardData(dashboardData);
  setOportunidades(Array.isArray(oportunidadesArray) ? oportunidadesArray : []);

} catch (err) {
  console.error('Error cargando dashboard:', err);
  setError('Error al cargar los datos del dashboard');
  toast.error('❌ Error al cargar el dashboard', {
    icon: '⚠️',
    theme: 'colored'
  });
} finally {
  setLoading(false);
}
};
const handleRefresh = () => {
loadData();
toast.info('🔄 Actualizando dashboard...', {
icon: '🔄',
autoClose: 2000
});
};
const calcularMetricas = () => {
if (!dashboardData) return null;
const metricas = dashboardData.metricas || {};

const oportunidadesActivas = Object.keys(metricas)
  .filter(etapa => !etapa.includes('cerrado'))
  .reduce((sum, etapa) => sum + (metricas[etapa]?.count || 0), 0);

const cerradasGanadas = metricas.cerrado_ganado?.count || 0;
const cerradasPerdidas = metricas.cerrado_perdido?.count || 0;

const totalCerradas = cerradasGanadas + cerradasPerdidas;
const tasaConversion = totalCerradas> 0 
  ? Math.round((cerradasGanadas / totalCerradas) * 100)
  : 0;

const valorPipeline = Object.keys(metricas)
  .filter(etapa => !etapa.includes('cerrado'))
  .reduce((sum, etapa) => sum + (metricas[etapa]?.valor || 0), 0);

const valorCerradoGanado = metricas.cerrado_ganado?.valor || 0;

const promedioValor = oportunidadesActivas> 0 
  ? valorPipeline / oportunidadesActivas 
  : 0;

return {
  oportunidadesActivas,
  cerradasGanadas,
  cerradasPerdidas,
  tasaConversion,
  valorPipeline,
  valorCerradoGanado,
  promedioValor
};
};
const metricasCalculadas = calcularMetricas();
if (loading) {
return (
 <Box sx={{
display: 'flex',
justifyContent: 'center',
alignItems: 'center',
minHeight: '100vh',
background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
}}>
 <Box sx={{ textAlign: 'center' }}>
 <CircularProgress
sx={{
color: 'white',
mb: 3,
width: 60,
height: 60
}}
/>
 <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
Cargando Dashboard...
 </Typography>
 <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 1 }}>
Preparando la mejor experiencia visual 🚀
 </Typography>
 </Box>
 </Box>
);
}
if (error) {
return (
 <Box sx={{
minHeight: '100vh',
background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
display: 'flex',
justifyContent: 'center',
alignItems: 'flex-start',
width: '100%'
} }>
 <Alert
severity="error"
sx={{
maxWidth: 600,
borderRadius: 3,
boxShadow: '0 8px 32px rgba(239, 68, 68, 0.2)',
border: '1px solid rgba(239, 68, 68, 0.2)'
}}
action={
 <Button
color="inherit"
size="small"
onClick={loadData}
startIcon={ <RefreshIcon />}
sx={{ fontWeight: 'bold' }}
>
Reintentar
 </Button>
}
>
 <Typography variant="h6" sx={{ mb: 1 }}>
❌ Error al cargar el dashboard
 </Typography>
{error}
 </Alert>
 </Box>
);
}
if (!dashboardData || !metricasCalculadas) {
return (
<Box sx={{
p: 3,
textAlign: 'center',
minHeight: '100vh',
background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
display: 'flex',
alignItems: 'center',
justifyContent: 'center'
}}>
<DashboardIcon sx={{ fontSize: 80, color: '#94a3b8', mb: 3, opacity: 0.5 }}/>
<Typography variant="h5" color="text.secondary" sx={{ mb: 1 }}>
No hay datos disponibles
</Typography>
<Typography variant="body2" color="text.secondary">
Intenta actualizar la página o contacta al administrador
</Typography>
</Box>
);
}
const metricas = dashboardData?.metricas || dashboardData?.data?.metricas || {};
const oportunidadesVencidas = dashboardData?.oportunidades_vencidas || dashboardData?.data?.oportunidades_vencidas || [];
return (
<Box sx={{ 
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
  width: '100%'
}}>

  {/* Header Compacto - Una sola línea */}
   <Box sx={{ 
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    color: 'white',
    px: 4,
    py: 1.5,
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }}>
    {/* Título */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <RocketIcon sx={{ fontSize: 22 }} />
      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '1rem' }}>
        Dashboard CRM
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.7, ml: 1 }}>
        Panel de control comercial
      </Typography>
    </Box>

    {/* Controles */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography variant="caption" sx={{ opacity: 0.8 }}>
        {new Date().toLocaleDateString('es-DO', { hour: '2-digit', minute: '2-digit' })}
      </Typography>
      <FormControl size="small" sx={{ minWidth: 140, bgcolor: 'rgba(255,255,255,0.1)', borderRadius: 2 }}>
        <Select
          value={periodo}
          onChange={(e) => setPeriodo(e.target.value)}
          sx={{ 
            color: 'white',
            fontSize: '0.82rem',
            py: 0,
            '& .MuiSelect-icon': { color: 'white' },
            '& fieldset': { border: 'none' },
            '& .MuiSelect-select': { py: 0.8 }
          }}
        >
          <MenuItem value="hoy">📅 Hoy</MenuItem>
          <MenuItem value="semana">📅 Esta semana</MenuItem>
          <MenuItem value="mes">📅 Este mes</MenuItem>
          <MenuItem value="trimestre">📅 Este trimestre</MenuItem>
        </Select>
      </FormControl>
      <Tooltip title="Exportar reporte" arrow>
        <IconButton size="small" sx={{ bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }, color: 'white' }}>
          <DownloadIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Button
        size="small"
        variant="contained"
        startIcon={<RefreshIcon fontSize="small" />}
        onClick={handleRefresh}
        sx={{ 
          bgcolor: 'white',
          color: COLORS.primary,
          '&:hover': { bgcolor: '#f8fafc' },
          borderRadius: 2,
          px: 2,
          py: 0.6,
          fontWeight: 'bold',
          textTransform: 'none',
          fontSize: '0.82rem'
        }}
      >
        Actualizar
      </Button>
    </Box>
   </Box>
  
  {/* Contenido principal - CON padding */}
  <Box sx={{ px: { xs: 2, sm: 3, md: 3 }, py: 4 }}>
 <Grid container spacing={3} sx={{ mb: 4 }}>
  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
    <Box sx={{ height: '100%' }}>
      <KpiCard
        title="Oportunidades Activas"
        value={metricasCalculadas.oportunidadesActivas}
        icon={PeopleIcon}
        color={COLORS.primary}
        trend="up"
        trendValue={12}
        subtitle={`${metricasCalculadas.cerradasGanadas} ganadas este mes`}
     />
    </Box>
  </Grid>
  
  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
    <Box sx={{ height: '100%' }}>
      <KpiCard
        title="Valor del Pipeline"
        value={`${(metricasCalculadas.valorPipeline / 1000000).toFixed(1)}M`}
        icon={MonetizationOnIcon}
        color={COLORS.success}
        trend="up"
        trendValue={8}
        subtitle={`Promedio: $${Math.round(metricasCalculadas.promedioValor).toLocaleString('es-DO')}`}
        prefix="$"
     />
    </Box>
  </Grid>
  
  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
    <Box sx={{ height: '100%' }}>
      <KpiCard
        title="Tasa de Conversión"
        value={`${metricasCalculadas.tasaConversion}%`}
        icon={PercentIcon}
        color={COLORS.warning}
        trend={metricasCalculadas.tasaConversion> 30 ? "up" : "down"}
        trendValue={metricasCalculadas.tasaConversion> 30 ? 5 : -2}
        subtitle={`${metricasCalculadas.cerradasGanadas} ganadas / ${metricasCalculadas.cerradasPerdidas} perdidas`}
     />
    </Box>
  </Grid>
  
  <Grid size={{ xs: 12, sm: 6, md: 3 }}>
    <Box sx={{ height: '100%' }}>
      <KpiCard
        title="Cerradas Ganadas"
        value={metricasCalculadas.cerradasGanadas}
        icon={StarIcon}
        color={COLORS.purple}
        trend="up"
        trendValue={15}
        subtitle={`Valor: $${Math.round(metricasCalculadas.valorCerradoGanado).toLocaleString('es-DO')}`}
     />
    </Box>
  </Grid>
</Grid>
    
    {/* Gráficos principales - FULL WIDTH */}
     <Grid container spacing={3} sx={{ mb: 4 }}>
       <Grid size={{ xs: 12, lg: 5 }}>
         <PipelineChart metricas={metricas} />
       </Grid>
      
       <Grid size={{ xs: 12, lg: 4 }}>
         <ValorDistributionChart metricas={metricas} />
       </Grid>

       <Grid size={{ xs: 12, lg: 3 }}>
         <Card sx={{
           height: '100%',
           borderRadius: 3,
           background: 'white',
           boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
           border: '1px solid #f1f5f9',
           overflow: 'hidden'
         }}>
           <CardHeader
             title={
               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                 <Box sx={{
                   p: 1,
                   background: alpha(COLORS.warning, 0.1),
                   borderRadius: 2,
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center'
                 }}>
                   <BarChartIcon sx={{ color: COLORS.warning, fontSize: 24 }} />
                 </Box>
                 <Typography variant="h6" fontWeight="bold" sx={{ color: COLORS.dark }}>
                   Metas Mensuales
                 </Typography>
               </Box>
             }
             subheader={
               <Typography variant="body2" color="text.secondary">
                 Progreso hacia los objetivos
               </Typography>
             }
             sx={{ pb: 2, borderBottom: '1px solid #f1f5f9' }}
          />
           <CardContent sx={{ p: 3 }}>
             <Box sx={{ mb: 3 }}>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="subtitle2" color="text.secondary">Oportunidades Activas</Typography>
                 <Typography variant="body2" sx={{ color: COLORS.success }}>+12%</Typography>
               </Box>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="body2">{metricasCalculadas.oportunidadesActivas} / 50</Typography>
                 <Typography variant="body2" fontWeight="bold">{Math.min(Math.round((metricasCalculadas.oportunidadesActivas/50)*100), 100)}%</Typography>
               </Box>
               <LinearProgress variant="determinate" value={Math.min((metricasCalculadas.oportunidadesActivas/50)*100, 100)}
                 sx={{ height: 10, borderRadius: 5, bgcolor: alpha(COLORS.primary, 0.1),
                   '& .MuiLinearProgress-bar': { borderRadius: 5, bgcolor: COLORS.primary } }} />
             </Box>
             <Box sx={{ mb: 3 }}>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="subtitle2" color="text.secondary">Valor del Pipeline</Typography>
                 <Typography variant="body2" sx={{ color: COLORS.success }}>+8%</Typography>
               </Box>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="body2">${(metricasCalculadas.valorPipeline/1000000).toFixed(1)}M / $150M</Typography>
                 <Typography variant="body2" fontWeight="bold">{Math.min(Math.round((metricasCalculadas.valorPipeline/150000000)*100), 100)}%</Typography>
               </Box>
               <LinearProgress variant="determinate" value={Math.min((metricasCalculadas.valorPipeline/150000000)*100, 100)}
                 sx={{ height: 10, borderRadius: 5, bgcolor: alpha(COLORS.success, 0.1),
                   '& .MuiLinearProgress-bar': { borderRadius: 5, bgcolor: COLORS.success } }} />
             </Box>
             <Box>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="subtitle2" color="text.secondary">Cerradas Ganadas</Typography>
                 <Typography variant="body2" sx={{ color: COLORS.success }}>+15%</Typography>
               </Box>
               <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                 <Typography variant="body2">{metricasCalculadas.cerradasGanadas} / 10</Typography>
                 <Typography variant="body2" fontWeight="bold">{Math.min(Math.round((metricasCalculadas.cerradasGanadas/10)*100), 100)}%</Typography>
               </Box>
               <LinearProgress variant="determinate" value={Math.min((metricasCalculadas.cerradasGanadas/10)*100, 100)}
                 sx={{ height: 10, borderRadius: 5, bgcolor: alpha(COLORS.purple, 0.1),
                   '& .MuiLinearProgress-bar': { borderRadius: 5, bgcolor: COLORS.purple } }} />
             </Box>
           </CardContent>
         </Card>
       </Grid>
     </Grid>
    
    {/* Tabla y alertas - FULL WIDTH */}
     <Grid container spacing={3}>
       <Grid size={{ xs: 12, lg: 7 }}>
         <OportunidadesRecientes oportunidades={oportunidades} />
       </Grid>
      
       <Grid size={{ xs: 12, lg: 5 }}>
         <AlertasSeguimientos oportunidadesVencidas={oportunidadesVencidas} />
       </Grid>
     </Grid>
   </Box>
  
  {/* Footer premium */}
   <Box sx={{ 
    mt: 6, 
    py: 4,
    px: 4,
    background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
    color: 'white',
    borderRadius: '24px 24px 0 0',
    textAlign: 'center'
  }}>
     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: 1200, mx: 'auto' }}>
       <Box sx={{ textAlign: 'left' }}>
         <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
           <DashboardIcon /> CRM Dashboard Pro
         </Typography>
         <Typography variant="caption" sx={{ opacity: 0.7 }}>
          Sistema de gestión comercial avanzado
         </Typography>
       </Box>
      
       <Box>
         <Typography variant="caption" sx={{ opacity: 0.7 }}>
          © {new Date().getFullYear()} Todos los derechos reservados
         </Typography>
         <Typography variant="caption" sx={{ display: 'block', opacity: 0.5, mt: 0.5 }}>
          Versión 2.0 • Diseñado con ❤️ en República Dominicana
         </Typography>
       </Box>
     </Box>
   </Box>
 </Box>
);
};
export default DashboardCRM;